<template>
  <div class="gxxt-button" :class="classStr" @click="handler">
    <button :disabled="disabled" :readonly="readonly" type="button">
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'middle',
    },
    color: {
      type: String,
      default: '#f50',
    }
  },
  emits: ['click'],
  data() {
    return {
      classArr: [],
      classStr: '',
    }
  },
  emits: ['click'],
  methods: {
    classUpdate() {
      this.classArr = []
      this.disabled && this.classArr.push('disabled')
      this.round && this.classArr.push('round')
      this.classArr.push(this.size ? this.size : 'middle')
      this.classArr.push(this.type)
      this.classStr = this.classArr.join(' ')
    },
    handler() {
      this.$emit('click')
    },
  },
  mounted() {
    this.classUpdate()
  },
  beforeUpdate() {
    this.classUpdate()
  },
}
</script>

<style scoped lang="less">
.gxxt-button {
  display: inline-block;
  box-sizing: border-box;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  font-weight: bold;
  // background: #fff;
  border: 2px solid v-bind(color);
}

.gxxt-button button {
  padding: 0 20px;
  font-size: 32px;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: none;
  color: v-bind(color);
}
.gxxt-button.primary button {
  color: #fff;
}
.gxxt-button.primary {
  border: none;
  background: linear-gradient(90deg, #ff8e00 0%, #ff5500 100%);
}
.gxxt-button.primary.disabled {
  background: linear-gradient(90deg, #d6d6d6 0%, #c1c1c1 100%);
  border: none;
}
.gxxt-button.disabled {
  background: #fff;
  border: 1px solid #aaa;
}
.gxxt-button.disabled button {
  color: #fff;
}
.gxxt-button.large.round {
  border-radius: 45px;
}

.gxxt-button.large {
  height: 90px;
}
.gxxt-button.large button {
  font-size: 36px;
}

.gxxt-button.small.round {
  border-radius: 27px;
}

.gxxt-button.small {
  height: 54px;
}

.gxxt-button.small button {
  font-size: 26px;
}

.gxxt-button.middle {
  height: 80px;
}
.gxxt-button.middle.round {
  border-radius: 40px;
}
.gxxt-button.middle button {
  font-size: 32px;
}
.gxxt-button.xs {
  height: 50px;
}
.gxxt-button.xs.round {
  border-radius: 25px;
}
.gxxt-button.xs button {
  font-size: 26px;
}
</style>